import React from 'react';
import { RecoilRoot } from 'recoil';
import { BrowserRouter } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

import AutoContextMenu from 'components/common/AutoContextMenu';
import AutoModals from 'components/common/AutoModals';
import BlockingSpinner from 'components/common/BlockingSpinner';
import LaravelPusher from 'components/common/LaravelPusher';
import AutoAuthByToken from 'components/AutoAuthByToken';
import ErrorWatcher from 'components/ErrorWatcher';
import RouteList from 'components/RouteList';

import theme from 'config/theme';

import 'swiper/css';
import 'swiper/css/navigation';


const App = () => {
    return (
        <HelmetProvider>
            <Helmet
                defaultTitle={process.env.REACT_APP_FULL_NAME}
                titleTemplate={`%s - ${process.env.REACT_APP_FULL_NAME}`}
            >
                <meta name="description" content="Shipping System CRM"/>
                <link rel="icon" href={process.env.REACT_APP_FAVICON}/>
            </Helmet>

            <BrowserRouter>
                <QueryParamProvider adapter={ReactRouter6Adapter}>
                    <RecoilRoot>
                        <ThemeProvider theme={theme}>
                            <SnackbarProvider
                                maxSnack={6}
                                anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
                            >
                                <LocalizationProvider dateAdapter={AdapterLuxon}>
                                    <DndProvider backend={HTML5Backend}>
                                    <CssBaseline/>
                                    <AutoAuthByToken/>
                                    <ErrorWatcher/>
                                    <RouteList />
                                    <AutoModals />
                                    <AutoContextMenu/>
                                    <BlockingSpinner />
                                    <LaravelPusher />
                                    </DndProvider>
                                </LocalizationProvider>
                            </SnackbarProvider>
                        </ThemeProvider>
                    </RecoilRoot>
                </QueryParamProvider>
            </BrowserRouter>
        </HelmetProvider>
    )
};

export default App;
